module.exports = __webpack_public_path__ + "static/61invgde-09d7e02c90dfd53baf3df39337a4b68f.gif";